export const ORDER_FORM_TRANSLATION_EN = {
  settlement_type: 'Settlement type',
  attendances: 'Services',
  startAt: 'Valid from',
  endAt: 'Valid to',
  organization: 'Organization',
  caregiver: 'Main caregiver',
  language_preference: 'preferred languages',
  has_gender_preference: 'There is a gender preference',
  gender: 'Gender',
  has_pet_preference: 'Pets should be taken care of ',
  pets: 'Kind of pets',
  planned_frequency: 'Planned volume',
  rhythm: 'Rhythm',
  visits: 'Visits',
  duration: 'Duration per visit',
  notes: 'Notes for disposition planning',
} as const;
